import { render, staticRenderFns } from "./PodesavanjaSistema.vue?vue&type=template&id=35150e92&scoped=true&"
import script from "./PodesavanjaSistema.vue?vue&type=script&lang=ts&"
export * from "./PodesavanjaSistema.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35150e92",
  null
  
)

export default component.exports